import { render, staticRenderFns } from "./MyCropmarketalaysisForYear.vue?vue&type=template&id=95c3d434&scoped=true&"
import script from "./MyCropmarketalaysisForYear.vue?vue&type=script&lang=js&"
export * from "./MyCropmarketalaysisForYear.vue?vue&type=script&lang=js&"
import style0 from "./MyCropmarketalaysisForYear.vue?vue&type=style&index=0&id=95c3d434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c3d434",
  null
  
)

export default component.exports